interface Props {
   children: React.ReactNode;
}

export default function ({ children }: Props) {
   return <div className="ml-8 flex gap-8 grow">{children}</div>;
}
